import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FarmManagementConditionList = Loadable(lazy(() => import("./FarmManagementConditionList")));
const FarmManagementConditionForm = Loadable(lazy(() => import("./FarmManagementConditionForm")));

const farmManagementConditionRoutes = [
  {
    path: "/FarmManagementCondition/FarmManagementConditionList",
    element: <FarmManagementConditionList />,
    permission: PERMISSIONS.FarmManagementConditions.Menu,
  },
  {
    path: "/FarmManagementCondition/FarmManagementConditionForm",
    element: <FarmManagementConditionForm />,
  },
  {
    path: "/FarmManagementCondition/FarmManagementConditionForm/:farmManagementConditionId",
    element: <FarmManagementConditionForm />,
  },
];

export default farmManagementConditionRoutes;
